<template>
    <BaseModal :id="id" dialog-class="modal-lg" content-class="p-3" :static-backdrop="true" :keyboard="false">
        <template #header>
                    <h3 class="mb-0">Ошибка</h3>
        </template>
                    <p>Произошла ошибка с получением информации о соглашении с публичной офертой.</p>
                    <p>Пожалуйста выйдите из системы, и войдите обратно.</p>
        <template #footer>
                    <button class="btn btn-danger mt-3" @click="logout">Выйти</button>
            <button type="button" class="d-none" data-bs-dismiss="modal" ref="agreementFailClose"></button>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal.vue'

export default {
    components: {
        BaseModal
    },
    data: () => ({
        id: 'agreementFetchFailModal'
    }),
    methods: {
        logout() {
            this.$emit('logout')
            this.$refs.agreementFailClose.click()
        }
    }
}

</script>

<style scoped>

.modal-content {
    height: 400px;
}

</style>
